import PromotionGamesFilter from './PromotionGamesFilter';

export default PromotionGamesFilter;
